import { skills } from '../utilities/projects_request'

export default function SkillsDisplay ({ projectSkills }) {
// console.log(projectSkills)
  const mapping = skills.filter(element => projectSkills.includes(element.name))

  return (
    <section className='flex flex-row flex-wrap
    gap-x-5
    justify-center
    place-content-evenly
    min-[200px]:gap-x-7
    max-[300px]:flex-nowrap
    max-[300px]:justify-evenly
    '
    >
      {
          mapping.map((skill) => {
            return (
              <div
                key={skill.id} className='place-self-center
              py-[15px]
              max-[400px]:w-[60px]
              max-[400px]:py-[5px]'
              >
                <img src={process.env.PUBLIC_URL + `${skill.link}`} alt={skill.alt} className={skill.class} />
              </div>
            )
          })
        }
    </section>
  )
}
